<app-header></app-header>
<main class="pages">

    <!--PAGE Hero Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 alt="net promoter score" class="h1-title mt-3">NPS<sup>&reg;</sup>, CSAT & CES</h1>
                    <h4 class="h2-title mt-lg-4 mt-2">Satisfy your customers to build a strong loyalty base and deliver meaningful result.</h4>
                    <p class="sub-text mt-3 text-justify">Want to know how loyal your customers are? Net Promoter Score<sup>&reg;</sup>, Customer Satisfaction Score and Customer Effort Score are trusted and proven mediums that get you in touch with your customers to quickly understand what
                        they feel about your product/service. They assist you in measuring customer satisfaction in the long term as well as short term and can be strongly correlated with your company growth.</p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="NPS Survey" title="Customer Experience" src="assets/illustrator/nps-survey.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="nps bg-light">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h2 alt="customer satisfaction survey" class="headings mt-lg-5 mt-3 mb-lg-4">Net Promoter Score<sup>&reg;</sup></h2>
                    <p class="sub-text">NPS focuses on measuring long term customer loyalty. It is proven to be an excellent predictor of customer behavior and is a single question type scale from 0-10 that assesses how likely your customers will recommend you to others.
                        Nowadays, it is used by large companies as an effective customer feedback tool. Respondents choose an answer between 0-10, with 0 being highly unlikely and 10 being very likely. This powerful metric is an indication of the growth
                        potential of your company. The results given are clear to understand and easy to interpret and can be used to compare your company’s performance with your competitors.</p>
                    <p>Depending on the score that is given to the Net Promoter question, three categories of people can be distinguished as -</p>
                </div>
            </div>
            <div class="row">
                <div class=" pb-lg-5 solutions text-center">
                    <div class="solution-points">
                        <ul class="nav nav-tabs tab-titles">
                            <li class="tablinks active">
                                <a class="nav-link" data-id="#Cs">
                                    <span class="sol-icon">
                                      <img src="assets/promoters.svg" alt="promoters">
                                    </span>
                                </a>
                                <h6 class="sol-title  text-center">Promoters</h6>
                            </li>
                            <li class="tablinks">
                                <a class="nav-link" data-id="#Ce">
                                    <span class="sol-icon">
                                      <img src="assets/passive.svg" alt="Passives">
                                  </span>
                                </a>
                                <h6 class="sol-title  text-center">Passives</h6>
                            </li>
                            <li class="tablinks">
                                <a class="nav-link" data-id="#Np">
                                    <span class="sol-icon">
                                    <img src="assets/detractors.svg" alt="Detractors">
                                </span>
                                </a>
                                <h6 class="sol-title  text-center">Detractors</h6>
                            </li>
                        </ul>

                        <div class="pt-2 pb-3 pb-lg-5">
                            <div id="Cs" class="tab-content" style=display:block>
                                <div class="">
                                    Respondents giving a 9 or 10 score, they are your loyal and enthusiastic customers. They are likely to act as brand ambassadors or influencers for your company who will help in the development of your clientele base.
                                </div>
                            </div>
                            <div id="Ce" class="tab-content">
                                <div>
                                    Respondents giving a 7 or 8 score, they include those customers who are satisfied with your product/service but will not recommend it to others. Though they will not promote your brand they will also not harm your brand with a negative word of mouth.
                                </div>
                            </div>
                            <div id="Np" class="tab-content">
                                <div>
                                    Respondents giving a 0 to 6 score, this counts the customers who are unhappy and dissatisfied with your product/service and will never buy from your company again. These customers will dissuade others also from purchasing your products or services.

                                </div>
                            </div>
                        </div>
                        <div class="alert alert-success blockquote mt-lg-5 d-none" role="alert">
                            By executing the NPS, you can know about the situation of your business. It makes it accessible for you to decide the respective improvements in your company to increase customer satisfaction and loyalty. Yet, it is essential to proceed with the decision
                            in a well arranged framework that ensures that the program is a complete success.
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="csat py-lg-5">
        <div class="container">
            <div class="row mob-column-reverse">
                <div class="col-lg-6">
                    <h2 alt="customer satisfaction survey" class="headings mb-lg-4">Customer Satisfaction </h2>
                    <p class="text-justify">Want to know if your customers are satisfied with your product/ service? Customer satisfaction effective survey solutions can help you gauge customers' opinions in a gist. It is considered a versatile solution because of its applicability
                        that allows you to ask customers a variety of questions. These surveys can help you identify happy customers who are likely to become your brand ambassadors. </p>
                    <p class="text-justify">A CSAT survey can help you unleash the opportunities or weaknesses in your product/service so that it creates a better and long lasting experience for your customers. Respondents claim an answer between 1-5, with 1 being highly unsatisfied
                        and 5 being very satisfied with the products/services received. The results can then be averaged out to provide an estimated CSAT score that can be used to enhance your customer experiences.</p>
                </div>
                <div class="col-lg-6">
                    <div class="image-wrapper pt-lg-3">
                        <img class="img-fluid mb-3 mb-lg-0" alt="NPS Survey" title="Customer Experience" src="assets/csat.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="ces py-lg-5 bg-light">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="image-wrapper py-lg-5 mb-lg-5">
                        <img class="img-fluid mb-3 mb-lg-0" alt="NPS Survey" title="Customer Experience" src="assets/ces.svg">
                    </div>
                </div>
                <div class="col-lg-6 pb-lg-5">
                    <h2 alt="customer satisfaction survey" class="headings mb-lg-4">Customer Effort Score</h2>
                    <p class="text-justify">Customer Effort surveys will help you understand the ease with which your customers are able to use your product or service. Effort is considered to be one of the key drivers in customer loyalty. The core idea behind CES surveys is
                        for organizations to create loyal customers and positive word of mouth by reducing customer effort through solving their issues quickly and conveniently.
                    </p>
                    <p class="text-justify">CES calculation aims to measure customer effort and is considered to be one of the easiest, most efficient metrics. It asks customers to rank the ease of using particular products and services on a scale of very difficult to very easy.
                        To solve problems in real time and improve user experience, using CES surveys can prove to be beneficial as they ensure a smooth and seamless experience.

                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="bg-primary py-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <iframe autoplay width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>